import { render, staticRenderFns } from "./CrudDiscountRule.vue?vue&type=template&id=3c3bcf96&scoped=true&"
import script from "./CrudDiscountRule.vue?vue&type=script&lang=js&"
export * from "./CrudDiscountRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bcf96",
  null
  
)

export default component.exports